export default {
  serverURL: 'https://server.aps-benin.com'// 'http://localhost:13000' //'https://backend-aa-vie.aps-benin.com'
}
